import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=ec1ab394&"
import script from "./NoPermission.vue?vue&type=script&lang=ts&"
export * from "./NoPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports